import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Autocomplete,
  Button,
  Container,
  Paper,
  FormControl,
  FormLabel,
} from "@mui/material";
import { getBranch, getCenter } from "../../../services/service";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";


const BranchAndCenterForm = ({ setSelectBranch }) => {
  const [branches, setBranches] = useState([]);
  const [centers, setCenters] = useState([]);
  const [loadingCenters, setLoadingCenters] = useState(false);
  const [formData, setFormData] = useState({
    branch: null,
    center: null,
  });

//   Fetch branches on component mount
  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const res = await getBranch();
        if (res) {
          setBranches(res?.branch);
        }
      } catch (error) {
        console.log("error", error);
        toast.error("Failed to load branches");
      }
    };
    fetchBranch();
  }, []);


  // Fetch centers when branch is selected
  useEffect(() => {
    const fetchCenters = async () => {
      if (formData.branch?.id) {
        setLoadingCenters(true);
        try {
          const res = await getCenter(formData.branch.id);
          if (res) {
            setCenters(res.center || []);
          }
        } catch (error) {
          console.log("error", error);
          toast.error("Failed to load centers");
        } finally {
          setLoadingCenters(false);
        }
      } else {
        setCenters([]);
      }
    };
    fetchCenters();
  }, [formData.branch]);

  const handleChange = (fieldName, value) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: value,
      // Reset center when branch changes
      ...(fieldName === 'branch' && { center: null })
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!formData.branch) {
      toast.error("Please select a branch");
      return;
    }

    if (!formData.center) {
      toast.error("Please select a center");
      return;
    }

    setSelectBranch(true);
    sessionStorage.setItem("isBranchSelected", true);
    sessionStorage.setItem("selectedBranch", formData.branch.id);
    sessionStorage.setItem("selectedCenter", formData.center.id);
  };


if(sessionStorage.getItem("loginByClient")==="true"){
    return <Loader/>
  }

  return (
    <Container maxWidth="xs">
      <Paper elevation={3} sx={{ p: 4, mt: 12 }}>
        <Typography variant="h5" component="h1" gutterBottom align="center">
          Branch and Center Selection
        </Typography>

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
          {/* Branch Selection */}
          <FormControl fullWidth sx={{ mb: 3 }}>
            <FormLabel component="legend">Select Branch</FormLabel>
            <Autocomplete
              options={branches}
              getOptionLabel={(option) => option.name}
              value={formData.branch}
              onChange={(event, newValue) => handleChange('branch', newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select branch"
                  variant="outlined"
                />
              )}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              noOptionsText="No branches found"
            />
          </FormControl>

          {/* Center Selection */}
          <FormControl fullWidth sx={{ mb: 3 }}>
            <FormLabel component="legend">Select Center</FormLabel>
            <Autocomplete
              options={centers}
              loading={loadingCenters}
              getOptionLabel={(option) => option.name}
              value={formData.center}
              onChange={(event, newValue) => handleChange('center', newValue)}
              disabled={!formData.branch || loadingCenters}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={
                    loadingCenters
                      ? "Loading centers..."
                      : formData.branch
                      ? "Select center"
                      : "Please select a branch first"
                  }
                  variant="outlined"
                />
              )}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              noOptionsText={
                formData.branch
                  ? "No centers available for this branch"
                  : "Select a branch first"
              }
            />
          </FormControl>

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            size="large"
            // disabled={!formData.branch || !formData.center}
          >
            Submit
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default BranchAndCenterForm;